import React from "react";

import "./Blog.css";
import NavLight from "../../components/NavLight";

import BlogPageIntroImg from "../../assets/blog/7_deadly_sins_of_customer_interviews.png";
import BlogsPreview from "../../components/BlogsPreview";
import FoundersGuide from "../../components/FoundersGuide";
import {CustomMetaHelmet} from "../../components/CustomMetaHelmet";
import {meta} from "../../assets/meta/meta";

function DeadlySinsOfCustomeInterviews() {
  return (
    <div className="Blog1">
      <CustomMetaHelmet meta={meta['6-biggest-customer-interview-mistakes']}/>
      <NavLight />
      <section className="blog-page">
        <article className="blog-page-container">
          <div>
            <h1>6 biggest customer interview mistakes</h1>
            <p>
              <i>
                Customer discovery and customer interviews are an essential and
                fundamental part of Product Management. Understanding and
                uncovering the depth of your customer&apos; s opinion can be the
                difference between launching a successful new product/service or
                one no one will use. From our experience preparation is key.
                Find below the 7 biggest mistakes Product Managers make when
                conducting customer interviews and how to avoid them.
              </i>
            </p>
          </div>
          <div>
            <figure>
              <img
                src={BlogPageIntroImg}
                alt="purple hand pressing a digital button"
              />
            </figure>
          </div>
          <div>
            <h2>1. Selecting wrong customers to interview</h2>
            <p>
              If you select the wrong customers to interview - your process will
              be flawed from the beginning. Without spending time on clearly
              defining the right profile of people, you would uncover surface
              insights at best.
              <p>&nbsp;</p>
              What is important to consider here is - you have limited time, so
              do your customers. Why waste yours and theirs on an interview that
              would ultimately not reveal anything about your topic of interest.
              E.g. If you are a weekly meal delivery company and would like to
              launch a new recipe category, selecting randomly some of your most
              frequent customers would not necessarily be the right approach.
              Consider looking into their purchase history - how often have they
              ordered the same meals. If indeed they always order the same, they
              would not be your target group for a brand new category. They
              might think they would want to order it, but based on past
              history, chances are they actually would not. So your data would
              not provide you with the needed insight in the end.
            </p>
            <h2>2. Asking too many yes/no questions</h2>
            <p>
              Let&apos; s assume you have done your research. You have selected
              10 &apos; super users&apos; . People who indeed would frequently
              order new types of meals. You have 30 mins or 1 hour with them.
              What should you do?
              <p>&nbsp;</p>
              What you shouldn&apos; t do is spend them on &apos;Yes/No&apos;
              questions, because at the end of that 1 hour you would find
              yourself with surface insights at best. E.g. If you ask them
              &apos; Would you order Indian food?' and they answer yes, you have
              not understood if that particular person likes Indian food vs
              likelihood to order often new exotic recipes. What you could ask
              instead is: &apos; Are you satisfied with the diversity of recipes
              and categories?&apos; this would much better tell you if they
              indeed are craving more variety. This would show you whether your
              idea of adding a new category would be well received. Instead of
              only finding out if they like Indian food with your &apos;
              yes/no&apos; question.
            </p>
            <h2>3. Doing all the talking</h2>
            <p>
              Allright, you have started to ask good, open-ended questions. But
              you start to get excited. Yes, you completely agree with them.
              Actually you have a personal opinion/story (doesn’t matter which),
              which completely resonates and would like to share with them.
              <p>&nbsp;</p>
              And you are sharing. And you are sharing. And so much time has
              been spent that you have 10 mins to wrap this interview. In your
              notes you cannot find any deep insights because you talked the
              majority of the interview.
              <p>&nbsp;</p>
              What we recommend you practice instead, is ‘active listening’.
              Listen in a way that you encourage the customer to share with you
              as many details and information as possible. You could do this by
              both using your body language, as well as with words such as
              ‘yes’, ‘mhm’, ‘go on’. Trust me you would find your data so much
              richer in the end.
            </p>
          </div>
          <div>
            <h2>4. Asking leading questions</h2>
            <p>
              Allright, you are doing your ‘active listening’ and your customer
              is doing the talking. What mistake you could do next - is to start
              asking ‘leading questions’. Questions that you ask in such a way
              that would increase the likelihood of you getting the answer you
              want.
              <p>&nbsp;</p>
              In our example a leading question could sound like: ‘Wouldn’t it
              be nice to have a bigger variety of recipes as part of our
              service?’. Well of course it would be nice! People always want to
              have more choices and more options. What you really want to find
              out is - is the variety of recipes your customer’s real pain
              point, or for example cheaper price, more frequent deliveries or
              bigger meal sizes. If you instead ask the leading question, what
              you could end up focusing on is the ‘nice to have’, and not what
              for them was really ‘need to have’ so they do not churn.
            </p>
            <h2>5. Not aware of confirmation bias </h2>
            <p>
              You are now asking really good, probing, open-ended customer
              interview questions. What you need to be aware of next is your
              ‘confirmation bias’. It can lead to the collection of flawed data.
              What is ‘confirmation bias’ in customer interviews? It is when you
              listen to what they say, but you hear only ‘what you would like’.
              <p>&nbsp;</p>
              In our case they might say: ‘More variety would be really great,
              but what can be even greater is to have bigger portion sizes’’.
              You can take that and write - they loved the idea of more variety.
              What a great idea I have - let’s spend my and the team’s time on
              doing this big bet.
            </p>
            <h2>6. Not aware of bias while analyzing</h2>
            <p>
              The best way to avoid biases in your analysis is to do a recording
              of the interview and use one of the AI transcription tools
              available to get it in text format.
              <p>&nbsp;</p>
              Afterwards analyze the data with Magic Feedback’s AI tool, which
              guarantees bias free analysis. As a bonus, it would analyze all
              the themes from all the interviews you have conducted in minutes.
              This way the rest of your Product Team can also quickly understand
              the insights you have uncovered and together you can agree on the
              next steps.
            </p>
          </div>
        </article>
      </section>
      <section className="related-blogs">
        <h1> You might also like</h1>
        <BlogsPreview />
      </section>
      <section className="FoundersGuide">
        <FoundersGuide />
      </section>
    </div>
  );
}

export default DeadlySinsOfCustomeInterviews;
